import { render, staticRenderFns } from "./MonitorDetailModal.vue?vue&type=template&id=ff031bfa&scoped=true"
import script from "./MonitorDetailModal.vue?vue&type=script&lang=js"
export * from "./MonitorDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MonitorDetailModal.vue?vue&type=style&index=0&id=ff031bfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff031bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff031bfa')) {
      api.createRecord('ff031bfa', component.options)
    } else {
      api.reload('ff031bfa', component.options)
    }
    module.hot.accept("./MonitorDetailModal.vue?vue&type=template&id=ff031bfa&scoped=true", function () {
      api.rerender('ff031bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/monitoringScreen/specificProduct/MonitorDetailModal.vue"
export default component.exports